module.exports = __webpack_public_path__ + "static/media/txt.863686ab.svg";